import { components, OptionProps, PlaceholderProps } from 'react-select';
import SVG from 'react-inlinesvg';
import treeStructureSvg from 'assets/icons/tree-structure.svg';
import BaseSelect from 'lib/BaseSelect';
import Chip from 'lib/Chip';
import { Color, Size } from 'lib/Chip/Chip.types';
import usePendoTracking from 'customHooks/usePendoTracking';
import { BaseSelectOptionProps } from 'lib/BaseSelect/BaseSelect.types';
import BaseSelectOption from 'lib/BaseSelect/BaseSelectOption';
import { RowGroupColumn } from 'customHooks/useRowGroupColumns';

interface DropdownGroupByProps {
  handleToggleRowGroupColumn: (rowGroupColumns: RowGroupColumn[]) => void;
  rowGroupColumns: RowGroupColumn[];
  selectedRowGroupColumns: RowGroupColumn[];
  reportType?: string;
  isDisabled?: boolean;
}

export const DropdownGroupBy: React.FC<DropdownGroupByProps> = ({
  handleToggleRowGroupColumn,
  rowGroupColumns,
  selectedRowGroupColumns,
  reportType = 'Report',
  isDisabled = false,
}) => {
  const { getPendoDataId } = usePendoTracking();
  const selectedGroups = selectedRowGroupColumns.filter(({ isSelected }) => isSelected);

  return (
    <div className="w-40">
      <BaseSelect
        dataTestId="group-by"
        name="Group by"
        options={rowGroupColumns}
        selectedValue={selectedGroups}
        isMultiple
        onSelect={(_, value: RowGroupColumn[]) => handleToggleRowGroupColumn(value)}
        closeMenuOnSelect={false}
        isSelectionVisible={false}
        customComponents={{
          Placeholder: ({ children, ...props }: PlaceholderProps) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <components.Placeholder {...props}>
              <div className="flex items-center flex-1">
                <SVG src={treeStructureSvg} className="text-neutral-600" />
                <div className="ml-2 mr-auto body-base text-neutral-600">Group by</div>
                {selectedGroups.length > 0 && (
                  <Chip
                    dataTestId="selected-groups-chip"
                    label={`${selectedGroups.length}`}
                    color={Color.PRIMARY}
                    size={Size.SMALL}
                  />
                )}
              </div>
              <div className="h-0 overflow-hidden">{children}</div>
            </components.Placeholder>
          ),
          Option: ({
            isSelected,
            innerRef,
            innerProps,
            children,
            data,
          }: BaseSelectOptionProps & OptionProps<RowGroupColumn>) => {
            return (
              <BaseSelectOption
                isMultiple
                isSelected={isSelected}
                innerRef={innerRef}
                innerProps={innerProps}
                dataPendoId={getPendoDataId(`${reportType} group ${data.code} option`)}
              >
                {children}
              </BaseSelectOption>
            );
          },
        }}
        withPortal={false}
        isDisabled={isDisabled}
      />
    </div>
  );
};
